import { DocInstructionMenu as CompDocInstructionMenu } from '@/features/ap_payees/components/DocInstructionMenu';
import { r2wc } from '@/wc/helper/render';

export const DocInstructionMenu = r2wc(CompDocInstructionMenu, {
  shadow: 'open',
  props: {
    disabledButton: 'boolean',
    onSendEmail: 'function',
    disabledSendmail: 'boolean',
    disabledExportPdf: 'boolean',
    payees: 'json',
    payeeQuery: 'json',
  },
});
